var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-show",class:_vm.type},[_c('base-svg',{attrs:{"name":_vm.chooseIcon(_vm.name)}}),_c('base-font',{staticClass:"category-text",attrs:{"tag":"span"}},[_vm._v(_vm._s(_vm.lang[_vm.name]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }